import axios from "axios";
import _Cookie from './cookie.js';
import { Message } from 'view-design';
import router from '../router'
import { getLoginUrl,existLogin,exitFreeLogin } from "@/api/userCenter";
let auth = '';

var authCheck = function () {
  auth = _Cookie.get('adminauth');
  if (auth !== undefined && auth != null && auth != 'null' && auth !== 'undefined') {
    return true;
  } else {
    return false;
  }
}
var paramsTrans = function (config) {
  if (config.params) {
    let obj = config.params;
    let keys = Object.keys(config.params);
    keys.forEach((key) => {
      if ((typeof obj[key]) == "string") {
        if (obj[key].indexOf("[") > -1 || obj[key].indexOf("[") > -1) {
          obj[key] = escape(obj[key]);
        }
      }
    })
  }
  return config;
}
var instance = axios.create({
  timeout: 60000,
  baseURL: '/services',
  responseType: 'json',
  withCredentials: false
});


instance.interceptors.request.use(function (config) {
  config = paramsTrans(config);
  config = {
    ...config,
    _v: Date.now()
  };
  if (authCheck()) {
    config.headers = {
      "Accept": "application/json;charset=UTF-8",
      "authtoken": "Bearer " + auth,
    };
  }
  return config
}, function (error) {
  return Promise.reject(error);
})
function getUrl() {
  let host = window.location.origin;
  let data = { host: host };
  getLoginUrl(data).then((res) => {
    window.location.href = res.data.data;
  });
}
// Add a response interceptor
instance.interceptors.response.use(function (response) {
  const res = response.data;
  if (res && res.code && res.code !== 0) {
    Message.error(res.msg || '网络繁忙')
    if (res.code == 4040) {
      _Cookie.remove('adminauth');
      getUrl();
    }
    return Promise.reject(response)
  } else {
    return response
  }
}, function (error) {
  console.log(error.response, '错误')
  if (error.response) {
    Message.error(error.response?.data?.error || "错误")
  }
  return Promise.reject(error.response)
})


export default instance